import React from 'react'
import { observer } from 'mobx-react-lite'
import { Stack } from '@mui/material'

import { Beat } from '../../core/types/Beat'
import { ANALYTICS_EVENTS, useEvent, useGlobalStore, useScreenSize } from '../../common'

import { InsightsMicroWidget } from '../../microinsights'
import { TRENDS_ANALYTICS_METADATA } from '../constants/TrendsWidget'

interface TrendsMicroInsightsProps {
  beats: Beat[]
  onInsightCardClick?: (beat?: Beat) => void
}

const TrendsMicroInsights: React.FC<TrendsMicroInsightsProps> = ({ beats, onInsightCardClick }) => {
  const { onEvent } = useEvent()
  const { isMobile, isDesktop, isLargeDesktop } = useScreenSize()
  const { beatStore, endpoint, sessionToken } = useGlobalStore()

  const isLargeLayout = isDesktop || isLargeDesktop
  const visibleCards = isLargeLayout || isMobile ? 1 : 2

  const handleLogOutUser = () => {
    return null
  }

  const handleCardClick = (beat?: Beat) => {
    onInsightCardClick?.(beat)
    onEvent(ANALYTICS_EVENTS.TRENDS_CLICK_INSIGHT, TRENDS_ANALYTICS_METADATA)
  }

  const carouselHeight = isLargeLayout ? 200 : 170
  const zeroStateHeight = isLargeLayout ? 170 : 124
  const containerHeight = beats.length > 0 ? carouselHeight : zeroStateHeight

  return (
    <Stack sx={{ height: containerHeight }}>
      <InsightsMicroWidget
        areBeatsLoading={beatStore.isLoading}
        beats={beats}
        cardStyle="border"
        endpoint={endpoint}
        headerSx={{ p: 0 }}
        logOutUser={handleLogOutUser}
        onCardClick={handleCardClick}
        showCarouselControls={true}
        showHeader={isLargeLayout}
        showIcon={true}
        showWithMargin={false}
        token={sessionToken}
        userHasFullInsightFeedBeats={false}
        visibleCardsCount={visibleCards}
      />
    </Stack>
  )
}

export default observer(TrendsMicroInsights)
